import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Header } from '../../header';
import { useNavigate } from "react-router-dom";
import { useNotify } from "tailwind-notifications-react";

export const OrderPage = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [order, setOrder] = useState(null);
    const [date, setDate] = useState([]);
    const [cart, setCart] = useState([]);
    const [status, setStatus] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [message, setMessage] = useState("");
    const orderId = searchParams.get('id');
    const token = localStorage.getItem('token');

    const orderStatuses = {
        success: {
          color: 'bg-orange-500',
          text: 'Ожидает сборки и отправки',
          priority: 1
        },
        packed: {
          color: 'bg-blue-500',
          text: 'В доставке',
          priority: 2
        },
        cancelled: {
          color: 'bg-red-500',
          text: 'Отменён',
          priority: 3
        },
        finished: {
          color: 'bg-green-400',
          text: 'Выполнен',
          priority: 4
        }
      };

    const notify = useNotify();

    const fullDate = new Date(date);
    const options = { day: 'numeric', month: 'long', year: 'numeric' };
    const formattedDate = fullDate.toLocaleDateString('ru-RU', options);

    const fetchOrder = async () => {
        try {
            const response = await axios.get(`https://api.alyonatestsite.store/api/order/?id=${orderId}`);
            setOrder(response.data)
            setDate(response.data.date)
            setCart(response.data.cart)
            setStatus(orderStatuses[order.status] || orderStatuses.success)

        } catch (error) {
            console.error('Ошибка загрузки заказа:', error);
        }
    };

    const handleContactClick = () => {
        setIsModalOpen(true);
    };

    const handleSendMessage = async () => {
        try {
            await axios.post(`https://api.alyonatestsite.store/api/telegram/contact/${order.id}`, { message }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setIsModalOpen(false);
            setMessage("");
            notify({
                title: "Успешно",
                message: `Сообщение было отправлено Клиенту. Проверьте беседу поддержки`,
                type: "success",
              });
        } catch (error) {
            console.error("Ошибка отправки сообщения:", error);
            notify({
                title: "Что-то пошло не так",
                message: `Сообщение почему-то не отправилось. Напиши Дане, хз`,
                type: "error",
              });
        }
    };

    useEffect(() => {
        fetchOrder();
    });

    if (!order) {
        return (
            <section>
                <Header fixed={false} />
                <div className='w-full min-h-screen flex flex-col lg:flex-row bg-white'>

                    <div className='w-full lg:w-1/2 flex flex-col p-6 lg:p-12 space-y-4'>

                        <div className='flex flex-row space-x-4'>
                            <button className='py-2 px-6 bg-blue-500 text-white w-fit rounded'
                                onClick={() => navigate('/dashboard/orders')}>
                                Назад
                            </button>
                        </div>

                        {[...Array(8)].map((_, index) => (
                            <div key={index} className="h-5 w-full bg-sky-200 relative overflow-hidden">
                                <div className="absolute inset-0 bg-gradient-to-r from-sky-200 via-sky-100 to-sky-200 animate-shimmer"></div>
                            </div>
                        ))}

                        <div className='mt-12'>
                            {[...Array(3)].map((_, index) => (
                                <div key={index} className="h-5 w-full bg-sky-200 relative overflow-hidden">
                                    <div className="absolute inset-0 bg-gradient-to-r from-sky-200 via-sky-100 to-sky-200 animate-shimmer"></div>
                                </div>
                            ))}
                        </div>

                    </div>

                    <div className='w-full lg:w-1/2 flex flex-col p-6 lg:p-12 items-end space-y-4'>
                        {[...Array(4)].map((_, index) => (
                            <div key={index} className="h-8 w-full bg-sky-200 relative overflow-hidden">
                                <div className="absolute inset-0 bg-gradient-to-r from-sky-200 via-sky-100 to-sky-200 animate-shimmer"></div>
                            </div>
                        ))}
                    </div>

                </div>
            </section>
        );
    }

    return (
        <section>
            <Header fixed={false} />

            <div className='w-full min-h-screen flex flex-col lg:flex-row bg-white'>

                <div className='w-full lg:w-1/2 flex flex-col p-6 lg:p-12'>

                    <div className='flex flex-row space-x-4'>
                        <button className='py-2 px-6 bg-blue-500 text-white w-fit rounded'
                            onClick={() => navigate('/dashboard/orders')}>
                            Назад
                        </button>

                        <a className={`py-2 px-6 bg-green-500 text-white w-fit rounded ${!order.cdekTrackCode && 'hidden'}`}
                            href={`https://lk.cdek.ru/order-history/${order.cdekTrackCode}/view`}
                            target="_blank"
                            rel="noreferrer">
                            Карточка заказа СДЭК
                        </a>

                        <a className={`py-2 px-6 bg-green-500 text-white w-fit rounded ${!order.cdekTrackCode && 'hidden'}`}
                            href={`https://lk.cdek.ru/print/print-barcodes?orderId=${order.cdekTrackCode}&format=A4&language=ru`}
                            target="_blank"
                            rel="noreferrer">
                            Накладная СДЭК
                        </a>
                    </div>

                    <div className='flex flex-row space-x-4 mt-2'>
                        <button className={`py-2 px-6 bg-sky-500 text-white w-fit rounded ${!order.isTelegramLinked && 'hidden'}`}
                            onClick={() => handleContactClick()}>
                            Связаться с клиентом в Telegram
                        </button>
                    </div>

                    <div className='flex flex-row items-center space-x-4 mt-6'>
                        <h1 className='font-lack text-2xl lg:text-4xl'>Заказ #{order.id}</h1>
                        <p className={`font-lack rounded px-2 py-1 text-white ${status.color}`}>
                            {status.text}
                        </p>
                    </div>

                    <div className='flex flex-row space-x-3 items-center mt-4'>
                        <div className='w-3 h-3 rounded-xl bg-gray-300' />
                        <p className='font-lack text-base lg:text-lg'>
                            Создан {formattedDate}
                        </p>
                    </div>

                    <div className='flex flex-row space-x-3 items-center'>
                        <div className='w-3 h-3 rounded-xl bg-gray-300' />
                        <p className='font-lack text-base lg:text-lg'>
                            {order.initials}
                        </p>
                    </div>

                    <div className='flex flex-row space-x-3 items-center'>
                        <div className='w-3 h-3 rounded-xl bg-gray-300' />
                        <p className='font-lack text-base lg:text-lg'>
                            {order.deliveryType === '136' ? `До ПВЗ: ${order.cdekPoint}` : `Курьером до двери: ${order.address}`}
                        </p>
                    </div>

                    <div className='flex flex-row space-x-3 items-center'>
                        <div className='w-3 h-3 rounded-xl bg-gray-300' />
                        <p className='font-lack text-base lg:text-lg text-blue-500 hover:cursor-pointer hover:underline hover:text-blue-800'
                        onClick={() => window.location.href = `tel:${order.phone}`}>
                            {order.phone}
                        </p>
                    </div>

                    <div className='flex flex-row space-x-3 items-center'>
                        <div className='w-3 h-3 rounded-xl bg-gray-300' />
                        <p className='font-lack text-base lg:text-lg'>
                            {order.email}
                        </p>
                    </div>

                    <div className='flex flex-row space-x-3 items-center'>
                        <div className='w-3 h-3 rounded-xl bg-gray-300' />
                        <p className='font-lack text-base lg:text-lg'>
                            Привязка к Telegram-боту: <a className={`${order.isTelegramLinked ? 'bg-green-300' : 'bg-sky-200'} px-1`}>{order.isTelegramLinked ? 'да' : 'нет'}</a>
                        </p>
                    </div>

                    <div className='flex flex-row space-x-3 items-center mt-6'>
                        <div className='w-3 h-3 rounded-xl bg-gray-300' />
                        <p className='font-lack text-base lg:text-lg whitespace-pre-line'>
                            ID платежа: <a className='px-1 bg-blue-100'>{order.invoiceID}</a>
                        </p>
                    </div>

                    <div className='mt-12'>
                        <div className="flex flex-wrap items-center gap-2">
                            <span className="font-lack">Стоимость товаров:</span>
                            <span className={`bg-sky-200 font-lack px-1 ${order.couponAmount != 0 && `line-through text-gray-500`}`}>{(order.amount - order.deliveryAmount) + order.couponAmount} руб.</span>
                            <span className={`font-lack text-lg ${order.couponAmount == 0 && 'hidden'} text-sky-500`}>{order.amount - order.deliveryAmount} руб.</span>
                        </div>
                        <h1 className='font-lack text-base lg:text-lg'>
                            Стоимость доставки СДЭК: <a className='bg-sky-200 px-1'>{order.deliveryAmount}</a> руб.
                        </h1>
                        <div className="flex flex-wrap items-center gap-2">
                            <span className="text-2xl lg:text-3xl font-lack">Итого:</span>
                            <span className={`bg-sky-200 text-2xl lg:text-3xl font-lack px-1 ${order.couponAmount != 0 && `line-through text-gray-500`}`}>{order.amount + order.couponAmount} руб.</span>
                            <span className={`font-lack text-lg lg:text-xl ${order.couponAmount == 0 && 'hidden'} text-sky-500`}>{order.amount} руб.</span>
                        </div>
                        <h1 className={`${order.couponAmount == 0 && 'hidden'} mt-8 text-sky-500 font-lack text-xl`}>Использован промокод {order.coupon}</h1>
                    </div>

                </div>

                <div className='w-full lg:w-1/2 flex flex-col p-6 lg:p-12 items-end space-y-4'>

                    {cart.map((item) => (
                        <div key={item.id} className="flex flex-row justify-between items-center border-b border-gray-400 pb-4 w-full">
                            <div className="flex flex-col lg:flex-row items-start lg:items-center space-y-2 lg:space-y-0 lg:space-x-4">
                                <p className='text-base lg:text-lg flex flex-row items-center space-x-4'>
                                    {item.quantity} шт.
                                </p>
                                <a href={`/merch/product/?id=${item.id}`}>
                                    <img
                                        src={`https://api.alyonatestsite.store${item?.images[0]}`}
                                        alt={item.name}
                                        className="w-16 h-16 sm:w-20 sm:h-20 object-cover rounded-xl"
                                    />
                                </a>
                                <div className="flex flex-col">
                                    <a href={`/merch/product/?id=${item.id}`}
                                        className="font-lack text-base lg:text-lg sm:text-2xl hover:underline xl:w-5/6">{item.name}</a>
                                    <p className={`${!item.size && 'hidden'} text-sm sm:text-base`}>
                                        Размер: {item.size}
                                    </p>
                                    <h1 className="font-lack">
                                        {item.price} руб.
                                    </h1>
                                </div>
                            </div>
                            <div className="text-right">
                                <p className="text-base lg:text-lg sm:text-2xl font-lack">
                                    {item.quantity *
                                        (item.discount && item.discount > 0
                                            ? item.discount
                                            : item.price)}{" "}
                                    руб.
                                </p>
                            </div>
                        </div>
                    ))}

                </div>

            </div>

            {isModalOpen && (
                <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50'>
                    <div className='bg-white p-6 rounded-lg shadow-lg w-96'>
                        <h2 className='text-xl font-bold mb-4'>Укажите сообщение</h2>
                        <textarea
                            className='w-full p-2 border rounded'
                            rows='4'
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            placeholder='Текст сообщения будет отправлен клиенту.'
                        ></textarea>
                        <div className='flex justify-end space-x-2 mt-4'>
                            <button className='px-4 py-2 bg-gray-500 text-white rounded' onClick={() => setIsModalOpen(false)}>Отмена</button>
                            <button className='px-4 py-2 bg-sky-400 text-white rounded' onClick={handleSendMessage}>Отправить</button>
                        </div>
                    </div>
                </div>
            )}

        </section>
    );
};